module.exports = __webpack_public_path__ + "static/media/niatv_quote_online_dance_fitness.75d62f48.webp";